import React, { FC } from "react"
import SbEditable from "storyblok-react"
import { Testimonials } from ".."
import { StaticQuery, graphql } from "gatsby"
import { blokType } from "../../../types"

interface TestimonialsQueryProps {
  storyUuid: string
}

const TestimonialsQuery: FC<TestimonialsQueryProps> = ({ storyUuid }) => (
  <StaticQuery
    query={graphql`
      query {
        allStoryblokEntry(
          filter: { full_slug: { regex: "/^hult/config/testimonials/" } }
        ) {
          edges {
            node {
              uuid
              content
            }
          }
        }
      }
    `}
    render={(data) => {
      let story: any
      if (data && data.allStoryblokEntry) {
        data.allStoryblokEntry.edges.filter((e: any) => {
          if (e.node.uuid === storyUuid) {
            const block = JSON.parse(e.node.content)
            return (story = <Testimonials key={e.node.uuid} blok={block} />)
          }
          return story
        })
      }
      return story
    }}
  />
)

interface TestimonialWrapperProps {
  testimonial: string
}

interface TestimonialsWrapperWBLokProps {
  blok: TestimonialWrapperProps & blokType
}

export const TestimonialsWrapper: React.FC<TestimonialsWrapperWBLokProps> = ({
  blok,
}) => {
  return (
    <SbEditable content={blok}>
      {blok.testimonial && <TestimonialsQuery storyUuid={blok.testimonial} />}
    </SbEditable>
  )
}
